import { Navigate, useSearchParams } from "react-router-dom";

/**
 * Stripe Connect historically used `/vendor/onboarding` as return/refresh URL from `api/ops.mjs`.
 * That path was not registered in the SPA, so vendors landed on 404 after completing Stripe.
 * This route forwards to the dashboard with the same query semantics as `api/stripe.mjs` links.
 */
export default function VendorOnboardingRedirect() {
  const [sp] = useSearchParams();
  const status = sp.get("status");
  const refresh = sp.get("refresh");
  const next = new URLSearchParams();
  if (status === "completed") next.set("stripe", "connected");
  else if (refresh === "1") next.set("stripe", "reconnect");
  else next.set("stripe", "return");
  return <Navigate to={`/company/dashboard?${next.toString()}`} replace />;
}
